<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mt-3">
            MANUEL GONZÁLEZ PRADA<br>
            <span style="line-height: 100%;" class="fontMS300">
                APUNTES PARA LA HISTORIA
            </span>
            
            <span style="line-height: 100%;" class="fontMS300">
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio17/manuel-gonzalez-prada">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio17/manuel-gonzalez-prada">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio17/manuel-gonzalez-prada">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio17/GP_000.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-4 mb-1 libro">
                <a href="https://hdl.handle.net/20.500.14428/72311" target="_blank" style="color: black;">
                    <img class="p2" width="100%"
                        src="/assets/images/micrositio/micrositio17/GP_001.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada. 
                                <br>
                            </span>
                            Estudio Courret, 1902. 
                        </p>
                    </div>
                </a>
                <!--<img width="100%" src="/assets/images/micrositio/micrositio17/GP_001.jpg">-->
            </div>
            <div class="col-sm-8">
                <p class="fontMS500 font-24">
                    MANUEL GONZÁLEZ PRADA FUE UN PENSADOR IRREVERENTE, 
                    DESAFIANTE Y CRÍTICO. SU ACTITUD Y SU LENGUAJE FRONTAL 
                    Y HONESTO HA CAUTIVADO A DIVERSAS GENERACIONES DEL PERÚ, 
                    PERO MUCHAS VECES SU FUERTE PERSONALIDAD HA ECLIPSADO 
                    SU OBRA Y NO HA PERMITIDO SU REVISIÓN MÁS DETALLADA. 
                    EN LOS ÚLTIMOS AÑOS, DIVERSOS INVESTIGADORES HAN EMPEZADO 
                    A PROFUNDIZAR EN LAS DIVERSAS FACETAS DE SU OBRA LITERARIA Y POLÍTICA. 
                </p>
            </div>
            <div class="col-sm-12">
                <p class="fontMS100 text-justify font-24 text-gris mt-5 mb-3">
                    El presente recorrido parte de su legado provocador, plasmado en su poesía, su 
                    activismo político e incluso en su labor como director de la Biblioteca Nacional. A través de esta 
                    dimensión poco estudiada de la trayectoria de Manuel González Prada, se valora su compromiso 
                    político y responsabilidad hacia el servicio público. El recorrido se construye a partir de la 
                    Colección Luis Alberto Sánchez-Manuel González Prada, el acervo de la Hemeroteca Nacional y 
                    el archivo institucional de la Biblioteca Nacional.
                    <br>
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris_PR">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row mt-5">
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%" 
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-6" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            RITMO SOÑADO <br>
                        </p>
                    </div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    EXPERIMENTACIÓN Y RENOVACIÓN
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-justify font-24 p2">
                            COMO POETA Y CRÍTICO, MANUEL GONZÁLEZ PRADA PROPUSO ROMPER CON 
                            LAS FORMAS LITERARIAS TRADICIONALES. BUSCÓ LIBERARSE DEL CORSÉ DEL 
                            CONTEO SILÁBICO PARA ACERCARSE AL VERSO EN MOVIMIENTO. ESTUDIÓ LA 
                            POESÍA EN SUS DIVERSAS TRADICIONES PARA ENTENDER MEJOR LAS POSIBILIDADES 
                            DEL VERSO CASTELLANO. SEGÚN GONZÁLEZ PRADA, EL RITMO NO SOLO 
                            DEPENDE DE LAS SÍLABAS, SINO TAMBIÉN DE LA ENTONACIÓN, DE LAS 
                            INTENSIDADES Y LAS PAUSAS.
                            <br><br>
                        </p>
                        <div class="row mt-5">
                            <div class="col-sm-6 pr-4">
                                <div class="row">
                                    <div class="col-sm-6 mt-3 libro-small-4">
                                        <a href="http://hdl.handle.net/20.500.14428/79273" target="_blank" style="color: black;">
                                            <img class="p2" width="100%" height="100%"
                                                src="/assets/images/micrositio/micrositio17/GP_036.jpg">
                                            <div class="overlay">
                                                <p class="fontMS100 text-center">
                                                    <span class="fontMS500">
                                                        Manuel González Prada.  
                                                        <br>
                                                    </span>
                                                    <span class="fontMS100Italic">
                                                        Al Amor; Ritmo soñado.  
                                                        <br>
                                                    </span>
                                                    Copia original mecanografiada. 
                                                </p>
                                            </div>
                                        </a>

                                        <!--<img width="100%" height="100%" 
                                            src="/assets/images/general/imagen_vacia.jpg">-->
                                    </div>
                                    <div class="col-sm-6 mt-3 libro-small-4">
                                        <a href="https://hdl.handle.net/20.500.14428/62202" target="_blank" style="color: black;">
                                            <img class="p2" width="100%" height="100%"
                                                src="/assets/images/micrositio/micrositio17/GP_003.jpg">
                                            <div class="overlay">
                                                <p class="fontMS100 text-center">
                                                    <span class="fontMS500">
                                                        Manuel González Prada.  
                                                        <br>
                                                    </span>
                                                    <span class="fontMS100Italic">
                                                        Minúsculas.  
                                                        <br>
                                                    </span>
                                                    Tip. de El Lucero, 1909.
                                                </p>
                                            </div>
                                        </a>
                                        <!--<img width="100%" height="100%"
                                            src="/assets/images/micrositio/micrositio17/GP_003.jpg">-->
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 mt-3">
                                <p class="fontMS100 font-24 text-gris">
                                    Es esta búsqueda de experimentación y renovación lo que le convierte en referente 
                                    para las nuevas generaciones. César Vallejo y José María Eguren, dos poetas que 
                                    forjaron el camino entre el modernismo y la vanguardia, lo consideraban maestro 
                                    y fundador de la modernidad literaria.
                                </p>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm-6">
                                <div class="row">
                                    <div class="col-sm-9">
                                        <p class="fontMS700 font-20">
                                            <br><br>
                                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                                            <a href="https://hdl.handle.net/20.500.14428/33483" target="_blank"
                                                style="text-decoration: none;" class="text-gris">
                                                José Santos Chocano <br>
                                            </a>
                                            <span style="font-style:italic; color:gray;"> Poesías completas (prólogo).</span> 
    
                                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                                            <a href="https://hdl.handle.net/20.500.14428/64470" target="_blank"
                                                style="text-decoration: none;" class="text-gris">
                                                Federico Elguera y Federico Blume
                                            </a>
                                            <br>
                                            <span style="font-style:italic; color:gray;"> F+F Letrillas (nota preliminar).</span>
                                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                                        </p>
                                    </div>
                                    <div class="col-sm-3"></div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="row">
                                    <div class="col-sm-9">
                                        <p class="fontMS700 font-20">
                                            <br><br>
                                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                                            <a href="https://hdl.handle.net/20.500.14428/11220" target="_blank"
                                                style="text-decoration: none;" class="text-gris">
                                                José María Eguren <br>
                                            </a>
                                            <span style="font-style:italic; color:gray;"> La canción de las figuras (dedicatoria).</span> 
    
                                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                                            <a href="https://hdl.handle.net/20.500.14428/11595" target="_blank"
                                                style="text-decoration: none;" class="text-gris">
                                                César Vallejo
                                            </a>
                                            <br>
                                            <span style="font-style:italic; color:gray;"> Los heraldos negros (dedicatoria).</span>
                                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                                        </p>
                                    </div>
                                    <div class="col-sm-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoAzulO pb-0 bottom_cel">
    <div class="container">
        <div class="row marg4">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal2 font-40">
                            MI MANUEL
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal2 font-40">
                    UN ACERCAMIENTO A LA VIDA <br>
                    COTIDIANA DEL PENSADOR
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO2 pb-0 bottom_cel">
    <div class="container">
        <div class="row marg2">
            <div class="col-12">
                <div class="row mt-5">
                    <div class="col-sm-5 pr-4">
                        <img width="100%" src="/assets/images/micrositio/micrositio17/GP_004.jpg">
                        <p class="fontMS100 font-22 text-white font-italic mt-3 mr-5">
                            Imprentilla usada por Adriana de Verneuil y su hijo Alfredo para elaborar la primera
                            edición de Minúsculas en 1901. Fotografía de Tom Quiroz, realizada durante la
                            exposición “Libertad d’escribir El ritmo combativo de Manuel G. Prada" de la Casa
                            de la Literatura Peruana. Pieza custodiada por el Instituto Raúl Porras Barrenechea.
                        </p>
                    </div>
                    <div class="col-sm-7">
                        <p class="fontMS500 font-24 text-white">
                            MÁS QUE UN TEXTO BIOGRÁFICO, MI MANUEL ES 
                            LA AUTOBIOGRAFÍA DE ADRIANA DE VERNEUIL, LA 
                            VIUDA DE MANUEL GONZÁLEZ PRADA. A LO 
                            LARGO DE MÁS DE 500 PÁGINAS, LA AUTORA 
                            RELATA LA COTIDIANIDAD DE SU VIDA, DESDE SU 
                            INFANCIA EN FRANCIA HASTA LA MUERTE DE SU 
                            ESPOSO EN 1918. 
                            <br>
                        </p>
                        <br><br>
                        <p class="fontMS100 font-24 text-white">
                            Hurga en el lado afectivo de la Historia, conectando la 
                            experiencia individual con eventos trascendentales. Según la 
                            investigadora Isabel Tauzin-Castellanos, <span class="fontMS100Italic">Mi Manuel</span>: “legitima 
                            el espacio doméstico marginado y lo revalora como 
                            complementario de la esfera pública donde actúa el hombre 
                            político”. Así, el lector acompaña a la que fue su 
                            pareja durante su estancia en Europa. Se sumerge en la 
                            dinámica familiar al conocer el origen del primer poemario 
                            de Manuel González Prada, una edición artesanal, elaborada 
                            en miniatura por Adriana y su hijo Alfredo. Finalmente, 
                            presencia las insistentes visitas de editores, escritores 
                            y políticos a la casa familiar.
                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO2 bottom_cel">
    <div class="container">
        <div class="row marg3">
            <div class="col-12">
                <div class="row">
                    <!--<div class="col-sm-2"></div>-->
                    <div class="col-sm-6 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/11609" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_005.jpg">
                            <div class="overlay2">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Adriana Verneuil de González Prada. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Mi Manuel.  
                                        <br>
                                    </span>
                                    Editorial Cultura Antártica, 1947.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79279 " target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_006.jpg">
                            <div class="overlay2">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Adriana Verneuil de González Prada. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Mi Manuel.
                                        <br>
                                    </span>
                                    Manuscrito, 1940.
                                </p>
                            </div>
                        </a>
                    </div>
                    <!--<div class="col-sm-2"></div>-->
                </div>
                <br><br>
                <div class="row mt-4">
                    <div class="col-sm-12">
                        <a href="http://hdl.handle.net/20.500.14428/79576" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_007.jpg">
                        </a>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12">
                        <a href="http://hdl.handle.net/20.500.14428/79577" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_008.jpg">
                        </a>
                    </div>
                </div>
                <!--<div class="row mt-4">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4 mt-3">
                        <a [routerLink]="['/visor/RET-137']" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_007.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a [routerLink]="['/visor/RET-139']" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_008.jpg">
                        </a>
                    </div>
                    <div class="col-sm-2"></div>
                </div>-->

                <br><br>
                
                <div class="bottom_cel">
                    <br><br><br>
                </div>

                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br>

                <div class="bottom_cel">
                    <br><br><br>
                </div>

                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal2 font-40">
                            PROPAGANDA Y ATAQUE
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mt-3"  width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                </div>
                <br><br><br>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24 text-white text-center">
                            A TRAVÉS DEL PERIODISMO Y LA ACCIÓN DIRECTA, MANUEL GONZÁLEZ PRADA SE PRONUNCIÓ SOBRE LA 
                            SITUACIÓN DEL PAÍS, RECHAZANDO LA AUTORIDAD Y LA TIRANÍA EN TODAS LAS FORMAS, Y LUCHÓ TANTO 
                            POR LA LIBERTAD DEL INDIVIDUO COMO POR LA LIBERACIÓN DE LOS GRUPOS SUBYUGADOS. 
                            <br><br>
                        </p>
                        <p class="fontMS100 font-24 text-white text-justify">
                            Con una palabra directa y punzante atacó a los que abusaban del poder, exponiendo su 
                            corrupción y vacuidad intelectual. Defendió la libertad de expresión y alentó a la 
                            incipiente prensa anarquista y contestataria en el Perú.
                            <br>
                        </p>
                        <p class="fontMS100 font-24 text-white text-justify">
                            El 29 de julio de 1888, en un evento para recaudar fondos para recuperar Tacna y Arica tras la 
                            Guerra del Pacífico, González Prada presentó su histórico discurso en el Teatro Politeama. En 
                            dicho evento, invitó a un estudiante de secundaria, Miguel Urbina, a impartir su apasionada arenga 
                            ante el presidente Andrés A. Cáceres, acompañado de varios ministros. 
                            <br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro-small-5 mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79631" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio17/GP_009.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada.
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Cuidado con la bolsa. 
                                <br>
                            </span>
                            El Germinal, no. 8, 18 de febrero de 1899.
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro-small-6 mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79642" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio17/GP_033.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada.
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                El Estado. 
                                <br>
                            </span>
                            Los Parias, no. 7, octubre de 1904. Reproducido en Anarquía / Manuel González Prada. – Tercera edición. – Santiago de Chile: Ercilla, 1940. – p. 38-40.
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro-small-5 mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79661" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio17/GP_010.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            La Lucha, 6 de junio de 1914.
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro-small-5 mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79201" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio17/GP_011.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Discurso en el Politeama. 
                                <br>
                            </span>
                            Lima, Impr. Bolognesi, 1889
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro-small-5 mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79200" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio17/GP_012.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada. 
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Pájinas libres. 
                                <br>
                            </span>
                            París : Tip. de Paul Dupont, 1894.
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-1"></div>
        </div>
        <br><br><br><br>
        <div class="row">
            <div class="col-sm-9">
                <img class="p2" width="100%" height="90%"
                        src="/assets/images/micrositio/micrositio17/GP_032.jpg">
            </div>
            <div class="col-sm-3">
                <p class="fontMS100Italic text-white">
                    El teatro Politeama. En: “Velada
                    literaria musical organizada por el
                    Centro de Estudios Sociales”. El
                    Oprimido (mayo de 1908). 
                </p>
            </div>
        </div>
    </div>
</div>
<!-- TABLET/CEL -->
<div class="fondoAzulO c100">
    <div class="container">
        <div class="row marg4">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal2 font-40">
                            MI MANUEL
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal2 font-40">
                    UN ACERCAMIENTO A LA VIDA <br>
                    COTIDIANA DEL PENSADOR
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-5 pr-4">
                        <img width="100%" src="/assets/images/micrositio/micrositio17/GP_004.jpg">
                        <p class="fontMS100 font-20 text-white font-italic mt-3">
                            Imprentilla usada por Adriana de Verneuil y su hijo Alfredo para elaborar la primera
                            edición de Minúsculas en 1901. Fotografía de Tom Quiroz, realizada durante la
                            exposición “Libertad d’escribir El ritmo combativo de Manuel G. Prada" de la Casa
                            de la Literatura Peruana. Pieza custodiada por el Instituto Raúl Porras Barrenechea.
                        </p>
                    </div>
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24 text-white">
                            <br>
                            MÁS QUE UN TEXTO BIOGRÁFICO, MI MANUEL ES
                            LA AUTOBIOGRAFÍA DE ADRIANA DE VERNEUIL, LA
                            VIUDA DE MANUEL GONZÁLEZ PRADA. A LO
                            LARGO DE MÁS DE 500 PÁGINAS, LA AUTORA
                            RELATA LA COTIDIANIDAD DE SU VIDA, DESDE SU
                            INFANCIA EN FRANCIA HASTA LA MUERTE DE SU
                            ESPOSO EN 1918.
                            <br>
                        </p>
                        <br><br>
                        <p class="fontMS100 font-24 text-white">
                            Hurga en el lado afectivo de la Historia, conectando la
                            experiencia individual con eventos trascendentales. Según la
                            investigadora Isabel Tauzin-Castellanos, <span class="fontMS100Italic">Mi Manuel</span> “legitima
                            el espacio doméstico marginado y lo revalora como
                            complementario de la esfera pública donde actúa el hombre
                            político”. Así, el lector acompaña a la pareja durante su
                            estancia en Europa. Se sumerge en la dinámica familiar al
                            conocer el origen del primer poemario de Manuel González
                            Prada, una edición artesanal, elaborada en miniatura por
                            Adriana y su hijo Alfredo. Finalmente, presencia las
                            insistentes visitas de editores, escritores y políticos a la casa
                            familiar.
                            <br><br>
                        </p>
                    </div>
                </div>

                <div class="row">
                    <!--<div class="col-sm-2"></div>-->
                    <div class="col-sm-6 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/11609" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_005.jpg">
                            <div class="overlay2">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Adriana Verneuil de González Prada. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Mi Manuel.  
                                        <br>
                                    </span>
                                    Editorial Cultura Antártica, 1947.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79279 " target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_006.jpg">
                            <div class="overlay2">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Adriana Verneuil de González Prada. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Mi Manuel.
                                        <br>
                                    </span>
                                    Manuscrito, 1940.
                                </p>
                            </div>
                        </a>
                    </div>
                    <!--<div class="col-sm-2"></div>-->
                </div>
                <br><br>
                <div class="row mt-4">
                    <div class="col-sm-12">
                        <a href="http://hdl.handle.net/20.500.14428/79576" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_007.jpg">
                        </a>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12">
                        <a href="http://hdl.handle.net/20.500.14428/79577" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_008.jpg">
                        </a>
                    </div>
                </div>
                <!--<div class="row mt-4">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4 mt-3">
                        <a [routerLink]="['/visor/RET-137']" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_007.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a [routerLink]="['/visor/RET-139']" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_008.jpg">
                        </a>
                    </div>
                    <div class="col-sm-2"></div>
                </div>-->

                <br><br>
                
                <div class="bottom_cel">
                    <br><br><br>
                </div>

                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br>

                <div class="bottom_cel">
                    <br><br><br>
                </div>

                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal2 font-40">
                            PROPAGANDA Y ATAQUE
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mt-3"  width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                </div>
                <br><br><br>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24 text-white text-center">
                            A TRAVÉS DEL PERIODISMO Y LA ACCIÓN DIRECTA, MANUEL GONZÁLEZ PRADA SE PRONUNCIÓ SOBRE LA 
                            SITUACIÓN DEL PAÍS, RECHAZÓ LA AUTORIDAD EN TODAS LAS FORMAS Y LUCHÓ TANTO POR LA LIBERTAD 
                            DEL INDIVIDUO COMO POR LA LIBERACIÓN DE LOS GRUPOS SUBYUGADOS.
                            <br><br>
                        </p>
                        <p class="fontMS100 font-24 text-white text-justify">
                            Con una palabra directa e hiriente, atacó a los que abusaban del poder, exponiendo su 
                            corrupción y vacuidad mental. Defendió la libertad de expresión y alentó a la incipiente 
                            prensa anarquista y contestataria en el Perú.
                            <br>
                        </p>
                        <p class="fontMS100 font-24 text-white text-justify">
                            El 29 de julio de 1888, en un evento para recaudar fondos para recuperar Tacna y Arica tras la
                            Guerra del Pacífico, González Prada presentó su histórico discurso en el Teatro Politeama. Invitó
                            a un estudiante de secundaria, Miguel Urbina, a impartir su apasionada arenga ante el presidente
                            Andrés A. Cáceres, acompañado de varios ministros.
                            <br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png">
                <br><br>
                <p class="fontMS500 text-justify  font-24">
                    EN ESTA OBRA DE RECONSTITUCIÓN I VENGANZA NO CONTEMOS CON 
                    LOS HOMBRES DEL PASADO: LOS TRONCOS AÑOSOS I CARCOMIDOS 
                    PRODUJERON YA SUS FLORES DE AROMA DELETÉREO I SUS FRUTAS 
                    DE SABOR AMARGO. ¡QUE VENGAN ÁRBOLES NUEVOS A DAR FLORES 
                    NUEVAS I FRUTAS NUEVAS! ¡LOS VIEJOS A LA TUMBA, LOS JÓVENES A LA OBRA!
                    <br>
                </p>
                <div class="col-sm-12 text-right mt-3 mb-3">
                    <span class="fontMS300Italic font-24">Manuel González Prada, parte del Discurso en el Politeama, 1888.</span>
                </div>
                <img class="reflejo" width="100%" 
                src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco bottom_cel">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-6" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL PENSADOR REBELDE <br>
                        </p>
                    </div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    EN LA BIBLIOTECA NACIONAL
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24">
                            EN 1912 MANUEL GONZÁLEZ PRADA, SE CONVIERTE EN SERVIDOR PÚBLICO AL 
                            ASUMIR LA DIRECCIÓN DE LA BIBLIOTECA NACIONAL DEL PERÚ. <br><br>
                        </p>
                    </div>
                    <div class="row">
                        <div class="col-sm-5 pr-4">
                            <a href="http://hdl.handle.net/20.500.14428/79196"  target="_blank" style="color: black;">
                                <img class="p2" width="100%" height="99%"
                                    src="/assets/images/micrositio/micrositio17/GP_013.jpg">
                            </a>
                        </div>
                        <div class="col-sm-7">
                            <p class="fontMS100 text-justify font-24">
                                A pesar de su carácter irreverente y provocador, 
                                González Prada demuestra ser un funcionario meticuloso 
                                y dedicado. Su gestión estuvo caracterizada por su deseo 
                                de modernizar la institución. Inició la catalogación y 
                                sinceró la utilización de los recursos para adquirir nuevas 
                                publicaciones. Hizo los mayores esfuerzos por abrir las 
                                puertas de la biblioteca al público, y ordenó los criterios 
                                del servicio para hacerlo más ágil y eficiente. 
                                Aunque no llegó a implementar todas las reformas planteadas, 
                                logró modificar el espíritu aristocrático de la biblioteca por 
                                uno más transparente y democrático. 
                                <br>
                            </p>
                        </div>
                    </div>
                </div>
                <br><br><br>
                <div class="row">
                    <div class="col-sm-2 p-0">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-8 p-0">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS500 text-gris text-center font-40">
                            TRANSFERENCIA DEL CARGO
                        </p>
                    </div>
                    <div class="col-sm-2 p-0">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="c100">
                        <img class="lineCel mt-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <br><br><br>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24">
                            La renuncia de Ricardo Palma a la dirección de la Biblioteca Nacional ocasionó una gran 
                            conmoción entre los diversos intelectuales de la época, quienes la consideraron como un maltrato al 
                            autor de las Tradiciones Peruanas. Por tal motivo, la transferencia del cargo a González Prada 
                            estuvo signada por la controversia, mucho más, cuando este cuestionó la gestión de las colecciones 
                            e instalaciones bajo su predecesor. 
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row" style="margin-top:5%">
                            <div class="col-sm-1"></div>
                            <div class="col-sm-10">
                                <div class="row">
                                    <div class="col-sm-4 libro-small-3 mt-3">
                                        <a href="https://hdl.handle.net/20.500.14428/11058" target="_blank" style="color: black;">
                                            <img class="p2" width="100%" height="100%"
                                                src="/assets/images/micrositio/micrositio17/GP_014.jpg">
                                            <div class="overlay">
                                                <p class="fontMS100 text-center">
                                                    <span class="fontMS500">
                                                        Manuel González Prada. 
                                                        <br>
                                                    </span>
                                                    <span class="fontMS100Italic">
                                                        Nota informativa acerca de la Biblioteca Nacional. 
                                                        <br>
                                                    </span>
                                                    Lima, Impr. Arica, 1912.     
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-sm-4 libro-small-3 mt-3">
                                        <a href="https://hdl.handle.net/20.500.14428/21565" target="_blank" style="color: black;">
                                            <img class="p2" width="100%" height="100%"
                                                src="/assets/images/micrositio/micrositio17/GP_015.jpg">
                                            <div class="overlay">
                                                <p class="fontMS100 text-center">
                                                    <span class="fontMS500">
                                                        Ricardo Palma. 
                                                        <br>
                                                    </span>
                                                    <span class="fontMS100Italic">
                                                        Apuntes para la historia de la Biblioteca de Lima. 
                                                        <br>
                                                    </span>
                                                    Empresa Tip. "Unión", 1912.    
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-sm-4 mt-3">
                                        <a href="http://hdl.handle.net/20.500.14428/79202" target="_blank" style="color: black;">
                                            <img class="p2" width="100%" height="100%"
                                                src="/assets/images/micrositio/micrositio17/GP_034.jpg">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br><br><br>
        <div class="row marg5">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-7">
                        <img class="p2" width="100%" height="80%"
                                                src="/assets/images/micrositio/micrositio17/GP_016.jpg">
                        
                        <p class="fontMS100Italic mt-3">
                            Sala América de la Biblioteca Nacional. Década de 1920, autor
                            desconocido. Fuente: Imaginario y Memoria. 200 años de la
                            Biblioteca Nacional del Perú. Colección BNP.
                            <br><br><br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <p class="fontMS700 font-20">
                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                            <a href="https://hdl.handle.net/20.500.14428/63115" target="_blank"
                                style="text-decoration: none; font-weight: bold; font-style:italic; color:black;">
                                Manuel González Prada solicita un uniforme <br>
                                de invierno para el portero. <br>
                            </a>
                            <span class="text-gris"> 9 de agosto de 1912.</span> 

                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                            <a href="https://hdl.handle.net/20.500.14428/63120" target="_blank"
                                style="text-decoration: none; font-weight: bold; font-style:italic;color:black;">
                                Manuel González Prada describe las <br>
                                reparaciones necesarias en la Biblioteca.
                            </a>
                            <span class="text-gris"> 28 de agosto de 1912.</span> 

                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                            <a href="https://hdl.handle.net/20.500.14428/63114" target="_blank"
                                style="text-decoration: none; font-weight: bold; font-style:italic;color:black;">
                                Manuel González Prada recupera los <br>
                                espacios de la Biblioteca Nacional tras la <br>
                                Guerra del Pacífico.
                            </a>
                            <span class="text-gris"> 6 de mayo de 1912.</span>
                            
                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                            <a href="https://hdl.handle.net/20.500.14428/63107" target="_blank"
                                style="text-decoration: none; font-weight: bold; font-style:italic;color:black;">
                                Estadísticas de lectores de la Biblioteca Nacional del Perú.
                            </a>
                            <span class="text-gris"> 1912-1914.</span>
                            
                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2 p-0">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-8 p-0">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS500 text-gris text-center font-40">
                            RELACIONES INTERNACIONALES
                        </p>
                    </div>
                    <div class="col-sm-2 p-0">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="c100">
                        <img class="lineCel mt-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <br><br><br>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24">
                            Desde que asumió el cargo de director de la Biblioteca Nacional, Manuel González Prada tuvo 
                            que negociar las relaciones institucionales a nivel internacional. Una serie de cartas con 
                            libreros europeos demuestra su desconfianza ante las relaciones establecidas por su predecesor, 
                            mientras que su correspondencia con diversos funcionarios en México, Colombia y Ecuador deja 
                            constancia del fortalecimiento de los vínculos regionales. 
                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 mt-3 libro-small-5">
                <a href="https://hdl.handle.net/20.500.14428/63087" target="_blank" style="color: black;">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio17/GP_020.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada.  
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Intercambio con el librero Fernando Fé.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mt-3 libro-small-5">
                <a href="https://hdl.handle.net/20.500.14428/62689" target="_blank" style="color: black;">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio17/GP_021.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada.  
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Carta a la librería Herth y C. 
                                <br>
                            </span>
                            París, 1 de agosto de 1913.
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mt-3 libro-small-5">
                <a href="https://hdl.handle.net/20.500.14428/58170" target="_blank" style="color: black;">
                    <img width="100%" 
                        src="/assets/images/micrositio/micrositio17/GP_022.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Rogelio Fernández Güell. 
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Carta a Manuel González Prada.  
                                <br>
                            </span>
                            México, 13 de enero de 1913.  
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mt-3 libro-small-5">
                <a href="https://hdl.handle.net/20.500.14428/58169" target="_blank" style="color: black;">
                    <img width="100%" 
                        src="/assets/images/micrositio/micrositio17/GP_023.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Director de la Biblioteca Municipal de Ecuador.  
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Carta a Manuel González Prada.   
                                <br>
                            </span>
                            Ecuador, 25 febrero 1913, 21 marzo 1913, 5 marzo 1914.  
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mt-3 libro-small-5">
                <a href="https://hdl.handle.net/20.500.14428/58167" target="_blank" style="color: black;">
                    <img width="100%" 
                        src="/assets/images/micrositio/micrositio17/GP_024.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada.  
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Carta al Ministro del Perú en Colombia.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-1"></div>
        </div>
    </div>
</div>

<div class="fondoBlanco c100">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-6" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL PENSADOR REBELDE <br>
                        </p>
                    </div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    EN LA BIBLIOTECA NACIONAL
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24">
                            EN 1912 MANUEL GONZÁLEZ PRADA, SE CONVIERTE EN SERVIDOR PÚBLICO AL
                            ASUMIR LA DIRECCIÓN DE LA BIBLIOTECA NACIONAL DEL PERÚ. <br><br>
                        </p>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <a href="http://hdl.handle.net/20.500.14428/79196"  target="_blank" style="color: black;">
                                <img class="p2" width="100%" height="99%"
                                    src="/assets/images/micrositio/micrositio17/GP_013.jpg">
                            </a>
                        </div>
                        <div class="col-sm-12">
                            <p class="fontMS100 text-justify font-24">
                                A pesar de su carácter irreverente y provocador,
                                González Prada demuestra ser un funcionario
                                meticuloso y dedicado. Su gestión estuvo caracterizada
                                por su deseo de modernizar la institución. Inició la
                                catalogación y sinceró el uso de los recursos para
                                adquirir nuevas publicaciones. Quiso abrirle las puertas
                                de la biblioteca al público, y ordenó los criterios del
                                servicio para hacerlo más ágil y eficiente. Aunque no
                                llegó a implementar todas las reformas planteadas,
                                logró modificar el espíritu aristocrático de la biblioteca
                                por uno más transparente y democrático.
                                <br>
                            </p>
                        </div>
                    </div>
                </div>
                <br><br><br>
                <div class="row">
                    <div class="col-sm-2 p-0">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-8 p-0">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS500 text-gris text-center font-40">
                            TRANSFERENCIA DEL CARGO
                        </p>
                    </div>
                    <div class="col-sm-2 p-0">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="c100">
                        <img class="lineCel mt-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <br><br><br>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24">
                            La renuncia de Ricardo Palma a la dirección de la Biblioteca Nacional ocasionó una gran
                            conmoción entre diversos intelectuales de la época quienes la consideraron como un maltrato al
                            autor de Tradiciones peruanas. Por tal motivo, la transferencia del cargo a Prada estuvo signada
                            por la controversia cuando este cuestionó la gestión de las colecciones e instalaciones bajo su
                            predecesor.
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row" style="margin-top:5%">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-4 libro-small-3 mt-3">
                                        <a href="https://hdl.handle.net/20.500.14428/11058" target="_blank" style="color: black;">
                                            <img class="p2" width="100%" height="100%"
                                                src="/assets/images/micrositio/micrositio17/GP_014.jpg">
                                            <div class="overlay">
                                                <p class="fontMS100 text-center">
                                                    <span class="fontMS500">
                                                        Manuel González Prada. 
                                                        <br>
                                                    </span>
                                                    <span class="fontMS100Italic">
                                                        Nota informativa acerca de la Biblioteca Nacional. 
                                                        <br>
                                                    </span>
                                                    Lima, Impr. Arica, 1912.     
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-sm-4 libro-small-3 mt-3">
                                        <a href="https://hdl.handle.net/20.500.14428/21565" target="_blank" style="color: black;">
                                            <img class="p2" width="100%" height="100%"
                                                src="/assets/images/micrositio/micrositio17/GP_015.jpg">
                                            <div class="overlay">
                                                <p class="fontMS100 text-center">
                                                    <span class="fontMS500">
                                                        Ricardo Palma. 
                                                        <br>
                                                    </span>
                                                    <span class="fontMS100Italic">
                                                        Apuntes para la historia de la Biblioteca de Lima. 
                                                        <br>
                                                    </span>
                                                    Empresa Tip. "Unión", 1912.    
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-sm-4 mt-3">
                                        <a href="http://hdl.handle.net/20.500.14428/79202" target="_blank" style="color: black;">
                                            <img class="p2" width="100%" height="100%"
                                                src="/assets/images/micrositio/micrositio17/GP_034.jpg">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br><br><br>
        <div class="row marg5">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12">
                        <img class="p2" width="100%" height="80%"
                                                src="/assets/images/micrositio/micrositio17/GP_016.jpg">
                        
                        <p class="fontMS100Italic mt-3">
                            Sala América de la Biblioteca Nacional. Década de 1920, autor
                            desconocido. Fuente: Imaginario y Memoria. 200 años de la
                            Biblioteca Nacional del Perú. Colección BNP.
                            <br><br><br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-12">
                        <p class="fontMS700 font-20">
                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                            <a href="https://hdl.handle.net/20.500.14428/63115" target="_blank"
                                style="text-decoration: none; font-weight: bold; font-style:italic; color:black;">
                                Manuel González Prada solicita un uniforme <br>
                                de invierno para el portero. <br>
                            </a>
                            <span class="text-gris"> 9 de agosto de 1912.</span> 

                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                            <a href="https://hdl.handle.net/20.500.14428/63120" target="_blank"
                                style="text-decoration: none; font-weight: bold; font-style:italic;color:black;">
                                Manuel González Prada describe las <br>
                                reparaciones necesarias en la Biblioteca.
                            </a>
                            <span class="text-gris"> 28 de agosto de 1912.</span> 

                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                            <a href="https://hdl.handle.net/20.500.14428/63114" target="_blank"
                                style="text-decoration: none; font-weight: bold; font-style:italic;color:black;">
                                Manuel González Prada recupera los <br>
                                espacios de la Biblioteca Nacional tras la <br>
                                Guerra del Pacífico.
                            </a>
                            <span class="text-gris"> 6 de mayo de 1912.</span>
                            
                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                            <a href="https://hdl.handle.net/20.500.14428/63107" target="_blank"
                                style="text-decoration: none; font-weight: bold; font-style:italic;color:black;">
                                Estadísticas de lectores de la Biblioteca Nacional del Perú. 
                            </a>
                            <span class="text-gris"> 1912-1914.</span>
                            
                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2 p-0">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-8 p-0">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS500 text-gris text-center font-40">
                            RELACIONES INTERNACIONALES
                        </p>
                    </div>
                    <div class="col-sm-2 p-0">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="c100">
                        <img class="lineCel mt-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <br><br><br>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24">
                            Desde que asumió el cargo de director de la Biblioteca Nacional, 
                            Manuel González Prada tuvo que negociar las relaciones institucionales 
                            a nivel internacional. Una serie de cartas con libreros europeos demuestra su 
                            desconfianza ante las relaciones establecidas por su predecesor, mientras que 
                            su correspondencia con diversos funcionarios en México, Colombia y Ecuador deja 
                            constancia del fortalecimiento de los vínculos regionales. 
                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 mt-3 libro-small-5">
                <a href="https://hdl.handle.net/20.500.14428/63087" target="_blank" style="color: black;">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio17/GP_020.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada.  
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Intercambio con el librero Fernando Fé.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mt-3 libro-small-5">
                <a href="https://hdl.handle.net/20.500.14428/62689" target="_blank" style="color: black;">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio17/GP_021.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada.  
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Carta a la librería Herth y C. 
                                <br>
                            </span>
                            París, 1 de agosto de 1913.
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mt-3 libro-small-5">
                <a href="https://hdl.handle.net/20.500.14428/58170" target="_blank" style="color: black;">
                    <img width="100%" 
                        src="/assets/images/micrositio/micrositio17/GP_022.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Rogelio Fernández Güell. 
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Carta a Manuel González Prada.  
                                <br>
                            </span>
                            México, 13 de enero de 1913.  
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mt-3 libro-small-5">
                <a href="https://hdl.handle.net/20.500.14428/58169" target="_blank" style="color: black;">
                    <img width="100%" 
                        src="/assets/images/micrositio/micrositio17/GP_023.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Director de la Biblioteca Municipal de Ecuador.  
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Carta a Manuel González Prada.   
                                <br>
                            </span>
                            Ecuador, 25 febrero 1913, 21 marzo 1913, 5 marzo 1914.  
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mt-3 libro-small-5">
                <a href="https://hdl.handle.net/20.500.14428/58167" target="_blank" style="color: black;">
                    <img width="100%" 
                        src="/assets/images/micrositio/micrositio17/GP_024.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada.  
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                Carta al Ministro del Perú en Colombia.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-1"></div>
        </div>
    </div>
</div>


<div class="fondoBlanco1">
    <div class="container">
        <div class="row marg3">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1 p-0">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-10 p-0 bottom_cel">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS500 text-gris text-center font-40">
                            LA POLÍTICA Y LA FUNCIÓN PÚBLICA
                        </p>
                    </div>
                    <div class="col-sm-12 p-0 c100">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS500 text-gris text-center font-40">
                            LA POLÍTICA Y LA FUNCIÓN PÚBLICA
                        </p>
                    </div>
                    <div class="col-sm-1 p-0">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="c100">
                        <img class="lineCel mt-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <br><br><br>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24">
                            Ante el golpe militar de Oscar R. Benavides, González Prada presentó su renuncia a la Biblioteca 
                            Nacional. El nuevo régimen no aceptó su renuncia y, a pesar de la insistencia por retenerlo, no 
                            cambió de opinión. En represalia, se archivó la renuncia y se le destituyó. El nuevo gobierno de 
                            José Pardo lo restituyó en el cargo hasta su fallecimiento en 1918.
                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row marg5">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 mt-3 libro-small-4">
                        <a href="https://hdl.handle.net/20.500.14428/63118" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_025.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Manuel González Prada.  
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Intercambio de cartas con el Ministerio de Instrucción. 
                                        <br>
                                    </span>
                                    18 de mayo de 1914 y 20 de mayo de 1914.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro-small-4 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/58172" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_026.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Manuel González Prada.  
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Intercambio de cartas con el Ministerio de Instrucción.  
                                        <br>
                                    </span>
                                    25 de mayo de 1914. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3 libro-small-4">
                        <a href="https://hdl.handle.net/20.500.14428/62675" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_027.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Manuel González Prada.  
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta al Ministerio de Instrucción. 
                                        <br>
                                    </span>
                                    26 mayo 1914. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/62690" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_030.jpg">
                        </a>
                    </div>
                </div>
                <br><br><br>
            </div>
        </div>

        <div class="row marg3">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-sm-3 mt-3 libro-small-3">
                        <a href="http://hdl.handle.net/20.500.14428/79284" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_028.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Ministerio de Instrucción.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Circular Número 79, adjuntando la suprema 
                                        resolución de 5 de febrero de 1915, referida al depósito 
                                        de impresos nacionales en la Biblioteca Nacional. 
                                        <br>
                                    </span>
                                    29 de setiembre de 1916. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79294" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_031.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3 libro-small-3">
                        <a href="https://hdl.handle.net/20.500.14428/64142" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_029.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Manuel González Prada.  
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Memoria del director de la Biblioteca Nacional. 
                                        <br>
                                    </span>
                                    “La Opinión Nacional”, 1917.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col"></div>
                </div>
                <br><br><br><br>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%" style="margin-bottom: 2%;"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA VIGENCIA <br>
                        </p>
                    </div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    DE MANUEL GONZÁLEZ PRADA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%" style="margin-top: 2%;"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-7 bottom_cel">
                        <img class="p2 pr-5" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_017.jpg">
                    </div>
                    <div class="col-sm-12 c100">
                        <img width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_017.jpg">
                    </div>
                    <div class="col-sm-12 c100">
                        <p class="fontMS100 font-20 text-gris font-italic mt-2">
                            La actitud desafiante de Manuel González Prada tuvo un gran
                            impacto en la Generación del Centenario. Fiesta de la planta,
                            Universidad Popular González Prada, 1923. Fuente: Archivo Mariátegui.
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <p class="fontMS500 font-24 mt-3">
                            MANUEL GONZÁLEZ PRADA FUE UN HOMBRE DE ACCIÓN. 
                            PUBLICÓ POCOS LIBROS DURANTE SU VIDA, Y GRAN 
                            PARTE DEL CORPUS QUE HOY CONOCEMOS ES EL RESULTADO 
                            DE RELECTURAS Y EDICIONES REALIZADAS A PARTIR DE 
                            LOS ARCHIVOS QUE DEJÓ ANTES DE SU PARTIDA.
                        </p>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-5 bottom_cel">
                        <p class="fontMS100 font-20 text-gris font-italic mt-2 pr-5">
                            La actitud desafiante de Manuel González Prada tuvo un gran
                            impacto en la Generación del Centenario. Fiesta de la planta,
                            Universidad Popular González Prada, 1923. Fuente: Archivo Mariátegui.
                        </p>
                    </div>
                    <div class="col-sm-7 bottom_cel">
                        <p class="fontMS500 text-justify font-24 text-gris">
                            <br><br>
                            Su hijo, Alfredo González Prada, y el historiador Luis 
                            Alberto Sánchez elaboraron libros póstumos como 
                            <span class="fontMS500Italic">Baladas peruanas, Propaganda i ataque y Anarquía</span>. 
                            Más recientemente, la investigadora Isabelle Tauzin Castellanos también ha 
                            recopilado varios de los textos inéditos que se encuentran 
                            en la Colección Manuel González Prada de la Biblioteca Nacional 
                            del Perú, incluido el cuento anticlerical «EEl doctor Bandurria». 
                        </p>
                        <br>
                        <p class="fontMS500 text-justify font-24 text-gris">
                            Estos textos nos invitan a pensar en la idea del corpus del 
                            autor, quien demostró en sus principales obras su vehemencia 
                            y honestidad política y, en su obra literaria, su resaltante vena poética. 
                        </p>
                    </div>
                    <div class="col-sm-12 c100">
                        <p class="fontMS500 text-justify font-24 text-gris">
                            <br><br>
                            Su hijo, Alfredo González Prada, y el historiador Luis 
                            Alberto Sánchez elaboraron libros póstumos como 
                            <span class="fontMS500Italic">Baladas peruanas, Propaganda i ataque y Anarquía</span>. 
                            Más recientemente, la investigadora Isabelle Tauzin Castellanos también ha 
                            recopilado varios de los textos inéditos que se encuentran 
                            en la Colección Manuel González Prada de la Biblioteca Nacional 
                            del Perú, incluido el cuento anticlerical «EEl doctor Bandurria». 
                        </p>
                        <br>
                        <p class="fontMS500 text-justify font-24 text-gris">
                            Estos textos nos invitan a pensar en la idea del corpus del 
                            autor, quien demostró en sus principales obras su vehemencia 
                            y honestidad política y, en su obra literaria, su resaltante vena poética. 
                        </p>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-4 mt-3 libro-small-3">
                        <a href="http://hdl.handle.net/20.500.14428/79178" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_002.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Manuel González Prada.  
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Baladas peruanas. 
                                        <br>
                                    </span>
                                    Editorial Ercilla, 1935.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79294" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_035.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 libro-small-3">
                        <a href="https://hdl.handle.net/20.500.14428/63123" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio17/GP_019.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Manuel González Prada.  
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        El doctor bandurria. 
                                        <br>
                                    </span>
                                    Mecanografiado, 1900.
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="container_Morado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-3">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-40">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <img id="img_dialogo"
                            src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <p class="text-white text-justify font-24">
                    El 29 de julio de 1888, Manuel González Prada presenta su famoso “Discurso en el Politeama” en
                    un evento destinado a recaudar fondos para recuperar Tacna y Arica tras la Guerra del Pacífico.
                    Manuel González Prada no lee el discurso, sino que es recitado por un escolar.
                </p>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            Cómo cambia tu percepción del texto al saber que fue
                            presentado por un escolar? ¿Por qué crees que Manuel
                            González Prada tomó esa decisión?
                        </p>
                        <img class="c100 mt-3" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            Te invitamos a comparar el Discurso en el Politeama con
                            su correspondencia como director de la Biblioteca
                            Nacional. ¿Qué diferencias o semejanzas notas en el tono y
                            el contenido?
                        </p>
                        <img class="c100 mt-3" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            Manuel González Prada luchó incansablemente por la
                            libertad de expresión y denunciaba la influencia
                            económica y política en la prensa ¿Crees que esas
                            influencias persisten en los medios de comunicación hoy
                            en día? Si es así, ¿cuál es el impacto?
                        </p>
                        <img class="c100 mt-3" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mt-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Lino Salvador, L.E. (2013). </span>
                            <span class="fontMS100Italic text-gris">El ritmo y la
                                modernización de la lírica peruana. Los casos de González Prada, Eguren y
                                Valdelomar.
                            </span>
                            <span class="text-gris">Fondo Editorial USIL.</span><br>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Sobrevilla, D. (ed.) (2010). </span><br>
                            <span class="fontMS100Italic text-gris">¡Los jóvenes a la obra! Textos esenciales de
                                Manuel González Prada. Lima: </span>
                            <span class="text-gris">Fondo
                                Editorial del Congreso del Perú.</span><br>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Margarucci, I. (2020). </span><br>
                            <span class="fontMS100Italic text-gris">La ideología
                                anarquista de Manuel González Prada en la
                                prensa libertaria peruana de comienzos del
                                siglo XX. </span>
                            <span class="text-gris">En: Izquierdas. Vol. 49. </span><br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Tauzin-Castellanos, I. (2007).</span>
                            <span class="fontMS100Italic text-gris"> Adriana de
                                Verneuil: memorias de un olvido. En: Mujeres
                                que escriben en América Latina,
                            </span>
                            <span class="text-gris"> p. 187-200.
                                CEMHAL. </span><br>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Ward, T. (1998). </span><br>
                            <span class="fontMS100Italic text-gris">La anarquía inmanentista de
                                Manuel González Prada. </span>
                            <span class="text-gris">Peter Lang. </span><br>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Ward, T. (ed.). (2010). </span><br>
                            <span class="fontMS100Italic text-gris">La insólita modernidad
                                de Manuel González Prada,
                            </span>
                            <span class="text-gris">Lima: Red para el
                                Desarrollo de las Ciencias Sociales en el Perú.</span><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

